import React, { Component } from "react";
import { Col, Row, Spinner, Image, Modal } from "react-bootstrap";
import { InputCheck } from "./../../../components/forms/inputcheckComponent";
import { connect } from "react-redux";
import { getAllSubject } from "./../../../apis/tutors";

class SubjectModal extends Component {
  constructor() {
    super();
    this.state = {
      selectedSub: "maths",
      Allsubject: {},
      subjects: {},
      loader: false,
    };
  }
  componentDidMount = () => {
    const { tutorSettingSubject } = this.props;
    this.setState({
      loader: true,
      subjects: tutorSettingSubject,
    });

    getAllSubject()
      .then((res) =>
        this.setState({
          Allsubject: res.data,
          loader: false,
        })
      )
      .catch((err) => console.log(err));
    let subjects = this.props?.TutorInfoObj?.step1?.subjects;
    return subjects ? this.setState({ subjects }) : null;
  };

  componentDidUpdate = (prevProps) => {
    return prevProps?.tutorSettingSubject !== this.props?.tutorSettingSubject
      ? this.setState({ subjects: this.props?.tutorSettingSubject })
      : null;
  };
  selectSubject = (sub) => {
    this.setState({
      selectedSub: sub,
    });
  };

  SaveAndCancel = () => {
    const { subjects } = this.state;
    this.props.onHide();
  };

  checkExistObj = (subjects, headTitle, selectedSub) => {
    if (subjects.hasOwnProperty(selectedSub)) {
      if (subjects[selectedSub].hasOwnProperty(headTitle)) {
        return subjects;
      } else {
        subjects[selectedSub][headTitle] = [];
        return subjects;
      }
    } else {
      subjects[selectedSub] = {};
      subjects[selectedSub][headTitle] = [];
      return subjects;
    }
  };

  getInput = (headTitle, title, selectedSub) => {
    let { subjects } = this.state;
    subjects = this.checkExistObj(subjects, headTitle, selectedSub);
    subjects[selectedSub][headTitle].push(title);
    this.setState({
      subjects,
    });
  };
  remove = (headTitle, title, selectedSub) => {
    let { subjects } = this.state;
    subjects[selectedSub][headTitle] = subjects[selectedSub][headTitle]?.filter(
      (subject) => subject !== title
    );
    this.setState({
      subjects,
    });
  };

  scrollToRight = (e) => {
    let scrollStep = 200;
    e.preventDefault();

    var element = document.getElementById("head-title-id");
    let sl = element.scrollLeft,
      cw = element.scrollWidth;

    if (sl + scrollStep >= cw) {
      element.scrollTo(cw, 0);
    } else {
      element.scrollTo(sl + scrollStep, 0);
    }
  };

  scrollToLeft = (e) => {
    let scrollStep = 200;
    e.preventDefault();

    var element = document.getElementById("head-title-id");
    let sl = element.scrollLeft;

    if (sl - scrollStep <= 0) {
      element.scrollTo(0, 0);
    } else {
      element.scrollTo(sl - scrollStep, 0);
    }
  };

  render() {
    const { selectedSub, subjects, Allsubject, loader } = this.state;
    const { isModalSubject, onHide } = this.props;

    return (
      <div>
        <Modal
          size="lg"
          className="setting-subject-modal"
          scrollable={true}
          show={isModalSubject}
          onHide={onHide}
        >
          <Modal.Body style={{ overflow: "unset", padding: "0px 2px" }}>
            <Row className="tutoringInterest-Col flex-center-center">
              <Col
                lg={12}
                md={12}
                sm={12}
                xs={12}
                className="modal-content"
                style={{ border: "none", background: "none" }}
              >
                <Row className="header" style={{ padding: "14px 20px" }}>
                  <Col
                    lg={1}
                    md={1}
                    sm={3}
                    xs={3}
                    className="flex-start-center setting-back-spanCol"
                  >
                    <span
                      className="flex-center-center"
                      onClick={this.scrollToLeft}
                      style={{ background: "none" }}
                    >
                      <Image
                        src={require("./../../../assets/icons/back1.png")}
                      />
                    </span>
                  </Col>
                  <Col lg={10} md={10} sm={6} xs={6} className="modal-title">
                    <Row className="header_options" id="head-title-id">
                      {Allsubject
                        ? Object.keys(Allsubject).map((subject, index) => {
                            return (
                              <div
                                key={index}
                                // lg={2}
                                // md={2}
                                // sm={12}
                                // xs={12}
                                style={{ height: "100%" }}
                              >
                                <span
                                  className={`sub-txt 
                                  ${selectedSub === subject ? "active" : ""}
                                  `}
                                  style={{
                                    whiteSpace: "nowrap",
                                    padding: "0px 22px",
                                  }}
                                  onClick={() => this.selectSubject(subject)}
                                >
                                  {subject.charAt(0).toUpperCase() +
                                    subject.slice(1)}
                                </span>
                              </div>
                            );
                          })
                        : null}
                    </Row>
                  </Col>
                  <Col
                    lg={1}
                    md={1}
                    sm={3}
                    xs={3}
                    className="flex-start-center setting-next-spanCol"
                  >
                    <span
                      className="flex-center-center"
                      onClick={this.scrollToRight}
                      style={{ background: "none" }}
                    >
                      <Image
                        // style={{ width: "20px", marginLeft: "-5px" }}
                        src={require("./../../../assets/icons/forward.png")}
                      />
                    </span>
                  </Col>
                </Row>
                {/* <div style={{ borderBottom: "1px solid #00000033" }} /> */}

                <div className="modal-body">
                  {!loader ? (
                    Allsubject && Allsubject[selectedSub] ? (
                      Object.keys(Allsubject[selectedSub]).map(
                        (subject, index) => {
                          return (
                            <div key={index} className="modal_subject_Head">
                              <p className="modal_subject_title">
                                {subject.charAt(0).toUpperCase() +
                                  subject.slice(1)}
                              </p>
                              <div className="subject_category_wrap">
                                <div className="subject_category_item">
                                  {Allsubject[selectedSub][subject].length ? (
                                    Allsubject[selectedSub][
                                      subject
                                    ].map((level, i) => (
                                      <InputCheck
                                        key={i}
                                        selectedSub={selectedSub}
                                        obj={subjects}
                                        headTitle={subject}
                                        title={level}
                                        id={`${subject}${level}${i}`}
                                        getInput={this.getInput}
                                        remove={this.remove}
                                      />
                                    ))
                                  ) : (
                                    <InputCheck
                                      selectedSub={selectedSub}
                                      obj={subjects}
                                      headTitle={subject}
                                      title={"All"}
                                      id={`All${index}`}
                                      getInput={this.getInput}
                                      remove={this.remove}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          );
                        }
                      )
                    ) : (
                      ""
                    )
                  ) : (
                    <div className="flex-center-center">
                      <Spinner
                        animation="border"
                        style={{ width: "50px", height: "50px" }}
                      />
                    </div>
                  )}
                </div>

                <div
                  className="modal-footer"
                  style={{
                    padding: "10px 14px",
                    width: "100%",
                    marginTop: "8px",
                    borderTop: "1px solid rgba(0, 0, 0, 0.16)",
                  }}
                >
                  <div
                    className="row flex-between-center"
                    style={{ width: "100%" }}
                  >
                    <div onClick={onHide} className="cancel pointer" style={{ padding: "0px" }}>
                      Cancel
                    </div>
                    <div className="flex-end" style={{ padding: "0px" }}>
                      <button
                        className="btn-theme-green flex-center-center"
                        onClick={this.SaveAndCancel}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  const {
    TutorSettingReducer: { tutorSettingSubject },
  } = state;

  return {
    tutorSettingSubject,
  };
};
// const mapDispatchToProps = (dispatch) => {
//   return {
//     AddTutorInfo: (payload) =>
//       dispatch(ApplicationFormAction.AddTutorInfo(payload)),
//   };
// };

export default connect(mapStateToProps, null)(SubjectModal);
